import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  text-align: center;
  padding: 40px;
`;

export default function Footer() {
  return (
    <StyledFooter>&copy; 2025, Duszpasterstwo Rodzin OP Służew</StyledFooter>
  );
}
